import { render, staticRenderFns } from "./ModalExcluirEmpresa.vue?vue&type=template&id=25fce739&scoped=true&"
import script from "./ModalExcluirEmpresa.vue?vue&type=script&lang=js&"
export * from "./ModalExcluirEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./ModalExcluirEmpresa.vue?vue&type=style&index=0&id=25fce739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fce739",
  null
  
)

export default component.exports